var map = {
	"./403.gif": "./src/assets/images/403.gif",
	"./404.gif": "./src/assets/images/404.gif",
	"./five9-logo-black.svg": "./src/assets/images/five9-logo-black.svg",
	"./five9-logo-white.svg": "./src/assets/images/five9-logo-white.svg",
	"./maintenance.gif": "./src/assets/images/maintenance.gif"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";